import React, { useEffect, useState } from "react";
import { Dispatch, SetStateAction } from "react";
import { Nav, NavItem, NavLink, Button } from "reactstrap";
import {
  FaHome,
  FaInfoCircle,
  FaServicestack,
  FaEnvelope,
  FaSignOutAlt,
} from "react-icons/fa";
import { MultiOptionNavItem } from "../CustomNavBar";
import { useAppDispatch, useAppSelector } from "src/state/store/store";
import AuthenticatedView from "../hocs/AuthenticatedView";
import { Link, useNavigate } from "react-router-dom";
import { CNavBarItemT } from "src/navigation/navigationType";
import { setOffcanvasOpen } from "src/state/slices/asideslice";
import {
  setActiveAccount,
  updateUserDetails,
  userLogout,
} from "src/state/slices/authSlice";
import { STATIC } from "src/network/networkConfig";
import { getAuthorDetailsApi } from "src/network/api";

type CustomAsideBarProps = {
  isOpen: boolean;
  toggleSidebar: Dispatch<SetStateAction<boolean>>;
  openNavList: CNavBarItemT[];
};

const CustomAsideBar = ({
  isOpen,
  toggleSidebar,
  openNavList,
}: CustomAsideBarProps) => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const { user } = auth || {};
  const [userDetails, setUserDetails] = useState<any>(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const data = await getAuthorDetailsApi();
        setUserDetails(data.data);
        dispatch(updateUserDetails(data.data));
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    if (auth.activeAccount) fetchUserDetails();
  }, [auth.activeAccount]);

  const userName = user?.name || "User Name";
  const userRole = user?.type || " ";
  const profileImage = userDetails?.profile_image || STATIC.noImageURL;

  return (
    <div className="custom-asidebar">
      <div
        className={`overlay ${isOpen ? "overlay-show" : ""} ${
          auth.token == null ? "hide-asidebar" : ""
        }`}
        onClick={() => toggleSidebar(false)}
      ></div>

      {/* Sidebar */}
      <aside
        style={{ overflowY: "auto" }}
        className={`sidebar ${isOpen ? "sidebar-open" : "sidebar-closed"}`}
      >
        <AuthenticatedView>
          <div className="sidebar-header">
            <div
              className="profile-image"
              style={{
                width: "100px",
                height: "100px",
                overflow: "hidden",
                borderRadius: "50%",
                position: "relative",
                border: 0,
              }}
            >
              <img
                src={profileImage}
                alt="Profile"
                className="rounded-circle"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block",
                }}
              />
            </div>
            <h5 style={{ margin: 0, fontWeight: "bold", textAlign: "center" }}>
              {userName}
            </h5>
            <p
              style={{
                margin: 0,
                fontSize: "14px",
                color: "#d0d0d0",
                textTransform: "capitalize",
              }}
            >
              {userRole}
            </p>
          </div>
        </AuthenticatedView>

        {/* Close Button */}
        <Button
          onClick={() => toggleSidebar(false)}
          className="close-button sidebar-close-btn"
        >
          ✖
        </Button>
        {auth.linkedToken && (
          <AuthenticatedView>
            <div
              className="text-center w-100 text-white py-1"
              style={{ fontSize: 14, cursor: "pointer", background: "#434a85" }}
              onClick={() =>
                dispatch(
                  setActiveAccount(
                    auth.activeAccount == "reviewer" ? "author" : "reviewer"
                  )
                )
              }
            >
              <i className="fa fa-exchange"></i> Switch to{" "}
              {auth.activeAccount == "reviewer" ? "author" : "reviewer"}
            </div>
          </AuthenticatedView>
        )}

        {/* Navigation Links */}
        <Nav vertical className="mt-2">
          {openNavList.map((item, index) => {
            if (item.children != null) {
              return (
                <MultiOptionNavItem key={index} item={item} showIcons={true} />
              );
            }

            return (
              <NavItem key={index} className="nav-item">
                <Link
                  to={item.href}
                  className="nav-link"
                  onClick={() => {
                    if (item?.onClick != null) item?.onClick(dispatch);
                    if (item.label.toLowerCase() === "logout") {
                      dispatch(userLogout());
                      dispatch(setOffcanvasOpen(false));
                    }
                  }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                </Link>
              </NavItem>
            );
          })}
        </Nav>
      </aside>
    </div>
  );
};

export default CustomAsideBar;
